import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=706cc37e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Database.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Database.vue
// module id = 2293
// module chunks = 1